/**
 * queue #689 §UAT-2026-07-14-R689 §R689-1-⑦ — 검색 결과/앵커 딥링크로 진입한 문서 페이지에서
 * 대상 heading 을 일시 하이라이트하는 순수 DOM 유틸(리액트 의존 0). `ConsumerGuidePage`
 * (`/getting-started/consumer-guide#<slug>`)와 `DevStandardsPage`(`/standards#<slug>`) 양쪽이
 * 이 함수를 재사용한다(재구현 0 — §R689-3 구현 주의 6).
 */

/** 하이라이트 지속 시간(ms) */
const HIGHLIGHT_DURATION_MS = 1800;

/** 대상 엘리먼트에 부여하는 data 속성 — 스타일은 design-tokens 전역 CSS 1규칙(index.css) 이 담당 */
export const SEARCH_HIGHLIGHT_ATTR = 'data-search-highlight';

/**
 * `target`(엘리먼트 또는 그 `id`)에 `data-search-highlight="true"` 를 부여하고
 * `HIGHLIGHT_DURATION_MS` 후 자동 제거한다. 반환한 cleanup 함수를 호출하면 즉시 제거 +
 * 예약된 타이머를 취소한다 — 호출자는 이 cleanup 을 React `useEffect` 의 리턴값(언마운트) 또는
 * 연속 hash 변경 시 이전 호출 결과에 호출해 하이라이트 누적을 막는다(§R689-3 구현 주의 6).
 * 대상이 없으면(아직 렌더 전 · 슬러그 불일치) 아무 것도 하지 않는 no-op cleanup 을 반환한다.
 */
export function highlightAnchorTarget(target: HTMLElement | string | null | undefined): () => void {
  const el = typeof target === 'string' ? document.getElementById(target) : target;
  if (!el) return () => undefined;

  el.setAttribute(SEARCH_HIGHLIGHT_ATTR, 'true');
  const timer = setTimeout(() => el.removeAttribute(SEARCH_HIGHLIGHT_ATTR), HIGHLIGHT_DURATION_MS);

  return () => {
    clearTimeout(timer);
    el.removeAttribute(SEARCH_HIGHLIGHT_ATTR);
  };
}
